import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { Button } from '@pkg/components/Sections';
import { YatSprite } from '@pkg/components/YatSprite';

export const Wrapper = styled.div<{ $zIndexTop?: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    padding: 0;

    width: 100%;
    height: 100vh;
    height: 100dvh;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 10px 0 10px 10px;
        min-height: 100vh;
        width: auto;

        z-index: 12;

        ${({ $zIndexTop }) =>
            $zIndexTop &&
            css`
                z-index: 11;
            `}
    }
`;

export const Background = styled(motion.div)<{ $zIndexTop?: boolean }>`
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 0;
    padding: 0;
    height: calc(100vh - 20px);
    min-height: calc(100vh - 20px);
    box-shadow: 0 0 25px 5px rgba(2, 1, 5, 0.5);
    border-radius: 20px;
    background-color: #151327;
    pointer-events: none;

    ${({ $zIndexTop }) =>
        $zIndexTop &&
        css`
            z-index: 10;
        `}
`;

export const Sidebar = styled(motion.div)`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100vh;
    height: 100dvh;
    background-color: #090719;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: auto;
        min-height: 100%;

        height: calc(100vh - 20px);

        background-color: transparent;
        border-radius: 20px;
    }
`;

export const SidebarMiddle = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    padding-bottom: 200px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-bottom: 0;
        margin-bottom: -1px;
    }
`;

export const SidebarBottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-self: end;
`;

export const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 0 20px 20px;
`;

export const Collapse = styled(motion.div)<{ $allowOverflow?: boolean; $maxHeight?: number }>`
    display: flex;
    flex-direction: column;
    overflow: hidden;

    overflow-y: auto;

    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;

    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        display: none;
    }

    mask-image: linear-gradient(0deg, transparent 0%, black 20px);

    ${({ $maxHeight }) =>
        $maxHeight &&
        css`
            max-height: ${$maxHeight}px;
        `}

    ${({ $allowOverflow }) =>
        $allowOverflow &&
        css`
            mask-image: none;
            overflow: visible;
        `}
`;

export const Collapseable = styled.div`
    display: flex;
    flex-direction: column;

    &:last-child {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    }
`;

export const Expanded = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    height: calc(100% - 95px);

    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;

    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: calc(100% - 95px - 79px);
        width: 330px;
    }
`;

export const Emoji = styled(YatSprite)<{ $isOpen?: boolean }>`
    width: 22px;
    height: 22px;
    flex-shrink: 0;

    margin: 1px;

    transition:
        filter 0.2s ease-in-out,
        opacity 0.2s ease-in-out;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 20px;
        height: 20px;
    }
`;

export const Description = styled.div`
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);

    padding: 0 20px 10px 20px;
`;

export const CloseButton = styled.button`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    z-index: 9;

    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;

    background: radial-gradient(67.31% 175% at 50% 148.75%, rgba(255, 255, 255, 0.001) 0%, rgba(0, 0, 0, 0) 100%),
        rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);

    border-radius: 40px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    padding: 0 25px;

    height: 40px;

    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }
`;

export const StyledButton = styled(Button)`
    white-space: nowrap;

    span {
        opacity: 0.5;
        margin: 0 4px;
        font-weight: 500;
    }
`;
